// extracted by mini-css-extract-plugin
module.exports = {"disclosureContainer":"UMyBPsbu","disclosure":"_25IB6f5V"};